import axios from "axios";

export default {
  state: {
    asientos: [],
    asientosSeleccionados: [],
    chipSeleccionados: false,
    asientosVisibles: [],
    contratos: [{
        id: 99,
        contrato: "Todos",
      },

    ],
    loading: false
  },
  mutations: {
    SET_ASIENTOS(state, asientosNuevos) {
      state.asientos = asientosNuevos
      // state.asientosSeleccionados = asientosNuevos
    },
    UPDATE_CONTRATOS(state, contratosNuevos) {
      contratosNuevos.forEach(contrato => {
        if (!state.contratos.includes(contrato)) {
          state.contratos.push(contrato);
        }
      });
    },
    SET_ASIENTOS_SELECCIONADOS(state, nuevosAsientos) {
      state.asientosSeleccionados = nuevosAsientos;
    },
    SET_ASIENTOS_VISIBLES(state, nuevosAsientos) {
      state.asientosVisibles = nuevosAsientos;
    },
    DELETE_SELECT_NO_VISIBLES(state) {
      let copiaSeleccionados = [...state.asientosSeleccionados]
      state.asientosSeleccionados.forEach((asiento) => {
        if (!state.asientosVisibles.includes(asiento)) {
          copiaSeleccionados.splice(copiaSeleccionados.indexOf(asiento), 1)
        }
      })
      state.asientosSeleccionados = [...copiaSeleccionados]
    }
  },
  actions: {
    getAsientos({commit}, fechaRegistro) {
      let asientosNuevos = []
      let counter = 1
      let params = {
        'fechaRegistro': fechaRegistro 
      }
      return axios.get('api/asientos', {params}).then(respuesta => {

        respuesta.data.forEach(asiento => {

          asientosNuevos.push({
            id: counter,
            cliente_id: asiento.cliente_id,
            cliente: asiento.cliente,
            tipoContrato: asiento.tipoContrato,
            contrato_id: asiento.contrato_id,
            fechaApertura: asiento.fechaApertura,
            horas: asiento.horas
          })
          counter++
        })
        // console.log(asientosNuevos)
        commit('SET_ASIENTOS', asientosNuevos)
      }).catch(err => console.log(err))
    },
    getContratos({
      commit
    }) {
      let contratosNuevos = []
      return axios.get("api/contratos").then(respuesta => {
        respuesta.data.forEach(contrato => {
          if (contrato.bolsa) {
            contratosNuevos.push({
              id: contrato.id,
              contrato: contrato.contrato
            })
          }
        })
        // console.log(contratosNuevos);
        commit('UPDATE_CONTRATOS', contratosNuevos)
      });
    },
    setAsientosSeleccionados({
      commit
    }, nuevoAsientosSeleccionados) {
      commit('SET_ASIENTOS_SELECCIONADOS', nuevoAsientosSeleccionados)
    },
    setAsientosVisibles({
      commit
    }, nuevoAsientosVisibles) {
      commit('SET_ASIENTOS_VISIBLES', nuevoAsientosVisibles)
    },
    eliminarSeleccionadosNoVisibles({
      commit
    }) {
      commit('DELETE_SELECT_NO_VISIBLES')
    },
    imprimirListado({
      commit,
      dispatch,
      state
    }, {
      type,
      asientos,
      fechaRegistro
    }) {
      if (!asientos.length)
        dispatch('setSnackbar', {
          tipo: "info",
          mensaje: "Selecciona por lo menos un registro para exportar.",
        }, {
          root: true
        })
      else {
        // commit('SET_LOADING_EXPORT', true);

        return axios
          .post("api/asientos/informe", {
            asientos: asientos,
          }, {
            params: {
              tipo: type,
            },
            responseType: "blob",
          })
          .then((response) => {
            dispatch('informe/download', {
              response: response,
              type: type,
              name: 'Saldos-' + fechaRegistro
            }, {
              root: true
            })
          })
          .catch(error => {
            let errorMessage = error.response ? error.response.data : error.request ? error.request : error.message
            dispatch('setSnackbar', {
              tipo: "error",
              mensaje: `${errorMessage}`,
            }, {
              root: true
            })
          })
          .finally(() => {
            // commit('SET_LOADING_EXPORT', false);
          })
      }
    },
  },
  getters: {
    asientos: state => state.asientos,
    contratos: state => state.contratos,
    asientosSeleccionados: state => state.asientosSeleccionados,
    asientosVisibles: state => state.asientosVisibles,
    cantidadSeleccionadosNoVisibles: state => {
      let cantidad = 0;
      state.asientosSeleccionados.forEach((asiento) => {
        if (!state.asientosVisibles.includes(asiento)) cantidad++;
      });
      return cantidad;
    }
  }
}